import React from 'react';
import SiteCharts from '../../../components/SiteCharts/SiteCharts';
import { endcUeSessionDropNrChartConfig } from '../chartConfigs';

/**
 * Props for the EndcUeSessionDropNrEcharts component
 */
interface EndcUeSessionDropNrEchartsProps {
  /** Callback function to toggle fullscreen mode */
  onFullscreenToggle: () => void;
  /** Current fullscreen state */
  isFullscreen: boolean;
}

/**
 * ENDC UE Session Drop Rate Chart (NR Site Level)
 * 
 * Displays EN-DC User Equipment session drop metrics for NR sites:
 * - Number of ENDC UE Session Drops (count)
 * - ENDC UE Session Drop Rate (percentage)
 * 
 * @component
 * @example
 * ```tsx
 * <EndcUeSessionDropNrEcharts onFullscreenToggle={handleFullscreen} isFullscreen={false} />
 * ```
 * 
 * @see {@link ../chartConfigs.ts} - Chart configuration (endcUeSessionDropNrChartConfig)
 * @see {@link ../../../components/SiteCharts/SiteCharts.tsx} - Template component
 * @see API: /api/nr/endc-ue-session-drop?site_name={siteName}
 */
const EndcUeSessionDropNrEcharts: React.FC<EndcUeSessionDropNrEchartsProps> = ({ 
  onFullscreenToggle, 
  isFullscreen 
}) => {
  return (
    <SiteCharts 
      config={endcUeSessionDropNrChartConfig}
      onFullscreenToggle={onFullscreenToggle}
      isFullscreen={isFullscreen}
    />
  );
};

export default EndcUeSessionDropNrEcharts;
